<template>
	<div
		ref="dropdown"
		style="opacity: 0; display: none; color: black"
		:style="{ transition: `opacity ${speed}ms ease-in-out` }"
		class="w-100 hebergement-dropdown py-3 px-2"
		@click.stop="() => {}"
	>
		<div v-for="i in totalAvailable" :key="i">
			<template v-if="i <= maximum">
				<div class="mx-3" v-if="i !== 1">
					<BorderHorizontal />
				</div>
				<div
					@click.stop="() => handleClick(i)"
					class="cursor-pointer col-12 d-flex flex-row justify-content-start px-0 m-3 align-items-center"
				>
					<div
						:class="selected === i && 'active'"
						class="hebergement-row me-2 rounded-circle border-primary-blue"
					></div>
					<div class="font-weight-600 font-size-16 text-start">
						<span class="d-flex flex-row nowrap">
							<span class="me-1">{{ i }}</span>
							<span v-if="i === 1">{{
								content.planningResult_hebergement
							}}</span>
							<span v-else>{{ content.planningResult_hebergements }}</span>
						</span>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "HebergementDropdown",
	components: {
		BorderHorizontal,
	},
	props: {
		selected: {
			type: Number,
			default: 1,
		},
		open: {
			type: Boolean,
			default: false,
		},
		totalAvailable: {
			type: Number,
			default: 1,
		},
		speed: {
			type: Number,
			default: 100,
		},
		maximum: {
			type: Number,
			default: 20,
		},
	},
	computed: {
		...mapState(["content"]),
	},
	methods: {
		handleClick(newSelected) {
			this.$emit("select", newSelected);
		},
		fadeIn(display = "block") {
			this.$refs["dropdown"].style.display = display;
			this.$nextTick(() => {
				this.$refs["dropdown"].style.opacity = 1;
			});
		},
		fadeOut() {
			this.$refs["dropdown"].style.opacity = 0;
			setTimeout(() => {
				this.$refs["dropdown"].style.display = "none";
			}, this.speed);
		},
	},
	watch: {
		open: function (newVal, oldVal) {
			if (newVal && !oldVal) {
				this.fadeIn();
			} else if (!newVal && oldVal) {
				this.fadeOut();
			}
		},
	},
};
</script>

<style scoped>
.hebergement-dropdown:hover {
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.26);
}

.hebergement-dropdown {
	min-width: 250px;
	border-radius: 8px;
	position: absolute;
	bottom: -5px;
	right: 0px;
	transform: translateY(100%);
	z-index: 5;
	background: white;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.13);
	transition: box-shadow 150ms ease-in-out;
	overflow-y: auto;
	overflow-x: hidden;
	max-height: 260px;
}

.hebergement-row {
	width: 20px;
	height: 20px;
	border: 2px solid var(--primary-blue);
	transition: border 100ms ease-in-out;
}

.hebergement-row.active {
	border: 5px solid var(--primary-blue);
}
</style>
